<p-floatLabel>
  <p-select #vendorSelector
        id="vendorSelector"
        name="vendorSelector"
        [options]="vendors"
        [(ngModel)]="selectedVendor"
        [showClear]="true"
        [checkmark]="true"
        [filter]="true"
        styleClass="w-100"
        [disabled]="isDisabled"
        (onChange)="onSelected()"
        optionLabel="name">
    <ng-template let-option pTemplate="item">
      {{ option?.name }}
    </ng-template>
  </p-select>
  <label for="vendorSelector">
    <app-label-content [isRequired]="isRequired">
      {{ l('::Vendor') }}
    </app-label-content>
  </label>
</p-floatLabel>